import { createReducer } from '@reduxjs/toolkit';

import { elevioActions } from '../elevio.actions';

/** Store of data relating to article feedback */
export type FeedbackState = {
  stage: FeedbackStage;
  email: string;
  feedback: string;
};
/**
 * This lets you know what stage in the process the user is in submitting
 * feedback.
 */
type FeedbackStage =
  /** Feedback widget hasn't been used, display positive and negative buttons. */
  | 'initial'
  /**
   * User has pressed the 'Feedback...' button, display the feedback message
   * form.
   */
  | 'form'
  /**
   * The 'Feedback...' message form is being submitted, display a thank you
   * message to the user.
   */
  | 'formSubmitting'
  /** The 'Mark as helpful' button has been pressed. */
  | 'helpfulSubmitting'
  /** An error occurred while submitting feedback. */
  | 'error';

export const initialFeedbackState: FeedbackState = {
  stage: 'initial',
  email: '',
  feedback: '',
};

export const feedbackReducer = createReducer(
  initialFeedbackState,
  (builder) => {
    builder
      .addCase(elevioActions.feedback.ticketAssisted, (state) => {
        state.stage = 'helpfulSubmitting';
      })
      .addCase(elevioActions.feedback.haveFeedbackPressed, (state, action) => {
        state.stage = action.payload.isPositive ? 'helpfulSubmitting' : 'form';
        state.email = action.payload.email;
      })
      .addCase(elevioActions.feedback.feedbackSubmit, (state) => {
        state.stage = 'formSubmitting';
      })
      .addCase(elevioActions.feedback.feedbackReset, (state) => {
        state.email = initialFeedbackState.email;
        state.feedback = initialFeedbackState.feedback;
        state.stage = initialFeedbackState.stage;
      })
      .addCase(elevioActions.feedback.feedbackChanged, (state, action) => {
        state.feedback = action.payload.feedback;
      });
  },
);
